import React from 'react';
import moment from 'moment';
import { IMPORT, EXPORT, DOMESTIC } from 'config/order-types';
import { PICKUP, DELIVERY } from 'config/movement-types';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import DescriptionListItem from '../../v2/DescriptionListItem';
const renderVessel = (shipment) => {
    var _a;
    const { t } = useTranslation();
    return (((_a = shipment === null || shipment === void 0 ? void 0 : shipment.order) === null || _a === void 0 ? void 0 : _a.vessel_or_rail) && (React.createElement(DescriptionListItem, { label: t('VESSEL', { count: 1 }), className: "mt-4 px-4" }, shipment.order.vessel_or_rail)));
};
const renderLFD = (shipment) => {
    const { t } = useTranslation();
    return (shipment.last_free_date && (React.createElement(DescriptionListItem, { label: t('TERMINAL_LFD'), className: "mt-4 px-4" }, moment(shipment.last_free_date).format('L'))));
};
const renderLastCutDate = (shipment) => {
    const { t } = useTranslation();
    return (shipment.last_cut_date && (React.createElement(DescriptionListItem, { label: titleize(t('LAST_CUT_DATE')), className: "mt-4 px-4" }, moment(shipment.last_cut_date).format('L'))));
};
const renderDates = (shipment) => {
    const { t } = useTranslation();
    return (React.createElement(React.Fragment, null,
        renderLFD(shipment),
        shipment.yard_available_date && (React.createElement(DescriptionListItem, { label: t('YARD_AVAILABLE'), className: "mt-4 px-4" }, moment(shipment.yard_available_date).format('L'))),
        shipment.yard_last_free_date && (React.createElement(DescriptionListItem, { label: t('YARD_LFD'), className: "mt-4 px-4" }, moment(shipment.yard_last_free_date).format('L')))));
};
const getBody = (shipment) => {
    const { order } = shipment;
    if ((order === null || order === void 0 ? void 0 : order.order_type) === EXPORT ||
        ((order === null || order === void 0 ? void 0 : order.order_type) === DOMESTIC && (order === null || order === void 0 ? void 0 : order.movement_type) === PICKUP)) {
        return (React.createElement(React.Fragment, null,
            renderVessel(shipment),
            renderLastCutDate(shipment)));
    }
    if ((order === null || order === void 0 ? void 0 : order.order_type) === IMPORT ||
        ((order === null || order === void 0 ? void 0 : order.order_type) === DOMESTIC && (order === null || order === void 0 ? void 0 : order.movement_type) === DELIVERY)) {
        return (React.createElement(React.Fragment, null,
            renderVessel(shipment),
            renderDates(shipment)));
    }
    return renderVessel(shipment);
};
export default function ({ shipment }) {
    return (React.createElement("div", { className: "flex overflow-x-auto sm:-mx-4" }, getBody(shipment)));
}
